export default __webpack_public_path__ + "static/media/logo7.331385d2.svg";